module.exports = __webpack_public_path__ + "img/Red-seguridad-p-800.db2b40fb.png";